<template>
  <v-card :color="colour" :dark="dark">
    <v-card-title primary-title class="mb-0">
      <div>
        <h3 class="subtitle-1">{{ title }}</h3>
      </div>
    </v-card-title>
    <v-card-text>
      <span class="display-1">{{ value.toLocaleString('en') }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'EnquiryCard',
  props: {
    title: String,
    value: [String, Number],
    colour: String,
    dark: Boolean
  }
};
</script>
